export default __webpack_public_path__ + "static/media/23t.1160b8f0.jpg";